export * from './seoText.continer';
export * from './seoText.model';
export * from './seoText.styled';
